import RegionsView from './Regions';

export default RegionsView;
